import { useEffect, useRef, useState } from "react";

import { buildGoogleMapsUrl } from "../../../shared/lib/googleMapsUrl";

const parseDec = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

function PublicPresentationMap({ location }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const [mapMissing, setMapMissing] = useState(false);

  const enabled = Boolean(location && location.map_enabled);
  const mapsUrl = enabled
    ? buildGoogleMapsUrl(location && location.latitude, location && location.longitude)
    : null;
  const lat = parseDec(location && location.latitude);
  const lng = parseDec(location && location.longitude);
  const hasCoords = Boolean(mapsUrl && lat !== null && lng !== null);

  useEffect(() => {
    if (!hasCoords) return undefined;
    if (typeof window === "undefined" || !window.L) {
      setMapMissing(true);
      return undefined;
    }
    if (!mapRef.current) return undefined;
    let map = null;
    try {
      map = window.L.map(mapRef.current, { scrollWheelZoom: false }).setView(
        [lat, lng],
        15,
      );
      window.L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(map);
      window.L.marker([lat, lng]).addTo(map);
      mapInstanceRef.current = map;
    } catch (_err) {
      setMapMissing(true);
      try {
        map?.remove();
      } catch (_removeErr) {
        /* ignore */
      }
    }
    return () => {
      try {
        mapInstanceRef.current?.remove();
      } catch (_err) {
        /* ignore */
      }
      mapInstanceRef.current = null;
    };
  }, [hasCoords, lat, lng]);

  if (!hasCoords) return null;

  return (
    <section className="presentation-map" aria-label="Мапа">
      <h2 className="presentation-section-title">
        <i className="fa-solid fa-location-dot" aria-hidden="true" />
        Розташування
      </h2>
      {mapMissing ? (
        <p className="presentation-map__fallback">Мапа недоступна.</p>
      ) : (
        <div ref={mapRef} className="presentation-map__canvas" data-testid="presentation-map" />
      )}
      {mapsUrl ? (
        <a
          className="action-btn presentation-map__external"
          href={mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="presentation-google-maps"
        >
          <i className="fa-solid fa-map-location-dot" aria-hidden="true" />
          Відкрити в Google Maps
        </a>
      ) : null}
    </section>
  );
}

export default PublicPresentationMap;
